export const RETRIEVE_TOKEN = 'RETRIEVE_TOKEN';
export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const STORE_NONCE = 'STORE_NONCE';
export const LOCATION = 'LOCATION';
